export enum Role {
  SUPER_ADMIN = 'Nightwatch Admin',
  ADMIN = 'Client Admin',
  ADVOCATE = 'Advocate',
}

export enum RoleCode {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  ADVOCATE = 'ADVOCATE',
}
